<mat-tree *ngIf="dataSource.data.length > 0" 
          style="background-color: transparent;"
          [dataSource]="dataSource" 
          [treeControl]="treeControl">
  <!--
  NODI FOGLIA
  -->
  <mat-tree-node *matTreeNodeDef="let node" 
                 matTreeNodeToggle 
                 matTreeNodePadding  matTreeNodePaddingIndent="20">
    <button mat-icon-button disabled></button>
    <mat-checkbox class="checklist-leaf-node"
                  [checked]="selectionModel.isSelected(node)"
                  (change)="toggleLeafItemSelection(node)">{{node.label}}</mat-checkbox>
  </mat-tree-node>
  <!--
  NODI NON FOGLIA
  -->
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" 
                 matTreeNodePadding matTreeNodePaddingIndent="20">
    <button mat-icon-button matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.label">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <mat-checkbox [checked]="descendantsAllSelected(node)"
                  [indeterminate]="descendantsPartiallySelected(node)"
                  (change)="toggleItemSelection(node)">{{node.label}}</mat-checkbox>
  </mat-tree-node>
</mat-tree>